export const ENQUIRY_TEMPLATE_FIELDS = [
  { value: "name", label: "Buyer name" },
  { value: "product", label: "Product" },
  { value: "company", label: "Company" },
  { value: "mobile", label: "Mobile" },
  { value: "email", label: "Email" },
  { value: "title", label: "Subject / title" },
];

export const DEFAULT_ENQUIRY_FIELD_ORDER = ENQUIRY_TEMPLATE_FIELDS.map((f) => f.value);

export function emptyTemplateVariables() {
  return { header: {}, body: {}, footer: {}, buttons: {} };
}

export function defaultEnquiryVariablePaths(slots) {
  const fill = (section) => {
    const keys = Object.keys(slots?.[section] || {}).sort(
      (a, b) => Number(a) - Number(b),
    );
    return Object.fromEntries(
      keys.map((key, idx) => [key, DEFAULT_ENQUIRY_FIELD_ORDER[idx] || "name"]),
    );
  };
  return {
    header: fill("header"),
    body: fill("body"),
    footer: fill("footer"),
    buttons: {},
  };
}

export const EMPTY_RULE = {
  name: "",
  subject_match_type: "contains",
  subject_pattern: "Enquiry for",
  action_type: "template",
  template_id: "",
  template_variables: emptyTemplateVariables(),
  message_text: "Thanks for your enquiry. We will contact you shortly.",
  parser_type: "indiamart_enquiry",
  create_lead: true,
  send_whatsapp: true,
  send_email: true,
  email_subject: "Thanks for your enquiry, {{name}}",
  email_body:
    "Hi {{name}},\n\nThank you for your enquiry about {{product}}.\nWe will get back to you soon.\n\nRegards",
  enabled: true,
  priority: 100,
};

export const POLL_INTERVAL_OPTIONS = [
  { label: "30 seconds", value: 30 },
  { label: "1 minute", value: 60 },
  { label: "5 minutes", value: 300 },
  { label: "10 minutes", value: 600 },
  { label: "15 minutes", value: 900 },
  { label: "30 minutes", value: 1800 },
  { label: "1 hour", value: 3600 },
  { label: "3 hours", value: 10800 },
  { label: "8 hours", value: 28800 },
  { label: "12 hours", value: 43200 },
  { label: "24 hours", value: 86400 },
];

export const BACKFILL_RANGE_OPTIONS = [
  { label: "Last 1 day", value: "1d" },
  { label: "Last 2 days", value: "2d" },
  { label: "Last 15 days", value: "15d" },
  { label: "Last 1 month", value: "1m" },
  { label: "Last 3 months", value: "3m" },
  { label: "Last 6 months", value: "6m" },
];

export const PERIOD_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Last 7 days", value: "7d" },
  { label: "Last 30 days", value: "30d" },
];

export function emptyMailbox() {
  return {
    name: "",
    enabled: true,
    imap_host: "imap.gmail.com",
    imap_port: 993,
    imap_username: "",
    imap_password: "",
    imap_mailbox: "INBOX",
    imap_secure: true,
    default_country_code: "91",
    poll_interval_sec: 1800,
  };
}

export function statusColor(status) {
  switch (status) {
    case "sent":
      return "success";
    case "failed":
      return "error";
    case "skipped":
      return "warning";
    default:
      return "default";
  }
}

export function mailboxStatusChip(mailbox) {
  if (mailbox?.imap_last_error) {
    return { label: "Error", color: "error" };
  }
  if (mailbox?.enabled) {
    return { label: "Enabled", color: "success" };
  }
  return { label: "Disabled", color: "default" };
}

export function templateDisplayName(template) {
  return template?.getTemplateName?.() || template?.templateName || template?.id || "template";
}

export function formatWhen(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString();
}
